import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslocoModule, provideTranslocoScope, TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule, DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { ReferentialsOutilAchatService } from '../referentials-outil-achat.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-gamme',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ConfirmDialogModule, ReactiveFormsModule, ToastModule, MessagesModule, MessageModule, ProgressSpinnerModule, TranslocoModule],
  providers: [DialogService, MessageService, provideTranslocoScope({ scope: 'referentiels' })],
  templateUrl: './add-gamme.component.html',
  styleUrl: './add-gamme.component.css'
})
export class AddGammeComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  disableSubmit = false;
  errors: GenericErrorResponse[] = [];
  submitting: boolean = false;

  gammeForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private otpService: ReferentialsOutilAchatService,
    private messageService: MessageService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.gammeForm = this.formBuilder.group({
      designation: ['', [Validators.required]],
    });
  }

  addGamme() {
    this.submitting = true;
    const designation = this.gammeForm.controls.designation.value;

    this.otpService.addGammeData(designation).subscribe({
      next: (response) => {
        this.handleInlineResponse(response);
        this.submitting = false;
      },
      error: (error) => {
        this.handleHttpErrorResponse(error);
      },
    });
  }

  private handleInlineResponse(response: InlineResponse): void {
    this.disableSubmit = false;
    if (response.success) {
      this.close(true);
    } else {
      this.errors = response.errors;
      this.messageService.add({
        severity: 'error',
        summary: this.translocoService.translate('error.popup.titre.defaut'),
        detail: 'Une erreur est survenue : ' + this.errors.map((e) => e.errorMsg).join(', '),
        life: 3000,
      });
    }
  }

  private handleHttpErrorResponse(error: HttpErrorResponse) {
    this.disableSubmit = false;
    this.errors = [];
    this.errors.push({
      errorInputId: error.status.toString(),
      errorCode: error.status.toString(),
      errorMsg: error.statusText,
    } as GenericErrorResponse);
    this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue : ' + error.statusText, life: 3000 });
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
